import React, { Component } from 'react';

import PaginationComponent from '../components/PaginationComponent';
import TableStateCard from '../components/TableStateCard';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { validateSession } from '../utils/functions';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';
import { PROVIDER_CATEGORIES, CURRENCIES, currencySymbol } from '../utils/enums';

var config = process.env;

// Estos modales se renderizan A MANO (`display: block`), sin el JS de Bootstrap. Bootstrap deja
// `.modal { overflow: hidden }` y sólo habilita el scroll en `.modal.show`, clase que pone su JS
// — que acá nunca corre. Resultado: un modal más alto que la pantalla se CORTA y no se llega al
// botón de guardar. Pasó al agregar el selector de moneda: el form quedó un campo más largo y el
// footer se fue abajo del viewport.
//
// El contenedor scrollea y además el body se topea, para que header y footer queden fijos y
// scrollee sólo el formulario. Mismo patrón que `TableProviderInvoicesComponent`.
const MODAL = { display: 'block', background: 'rgba(0,0,0,.4)', overflowY: 'auto' };
const MODAL_BODY = { maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' };

class TableProvidersComponent extends Component {

    constructor() {
        super();
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'name',
            sortDir: 'asc',
            data: [],
            loaded: false,
            role: 0,
            // ENI-223 — ABM. Hasta acá sólo se podían cambiar dos campos de un proveedor
            // existente: no había forma de crear uno ni de renombrarlo.
            modalAbierto: false,
            editandoId: null,     // null = alta
            formNombre: '',
            formCategoria: 'cafeteria',
            formConsignacion: false,
            formPlazo: '',
            formRut: '',
            formMoneda: 1,
            guardando: false,
            formError: '',
        };
    }

    async componentDidMount() {
        this.fetchData();
        let role = await validateSession();
        this.setState({ role: role });
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        const query = buildPaginationQuery({ page, limit, search, sortBy, sortDir });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}provider/product/complete?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true,
                });
            }
        });
    }

    toggleOrderable = (providerId, currentValue) => {
        const newValue = currentValue ? 0 : 1;
        const request = {
            method: 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ providerId, orderable: newValue })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider/product/orderable', request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
            } else {
                this.fetchData();
            }
        });
    }

    // ENI-92: setea la categoría del proveedor (define en qué flujos de reposición aparece).
    updateCategory = (providerId, category) => {
        const request = {
            method: 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ providerId, category })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider/product/category', request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
            } else {
                this.fetchData({ showLoader: false });
            }
        });
    }

    // ── ABM (ENI-223) ────────────────────────────────────────────────────────
    // La categoría arranca en 'cafeteria' y no en 'general' a propósito: desde ENI-187 el
    // filtro de la reposición es estricto, así que un proveedor en 'general' no aparece en
    // ninguna pantalla que filtre. Nacería invisible.
    abrirAlta = () => this.setState({
        modalAbierto: true, editandoId: null, formNombre: '', formCategoria: 'cafeteria',
        formConsignacion: false, formPlazo: '', formRut: '', formMoneda: 1, formError: '',
    });

    abrirEdicion = (item) => this.setState({
        modalAbierto: true, editandoId: item.providerId,
        formNombre: item.name || '', formCategoria: item.category || 'general',
        formConsignacion: !!Number(item.is_consignment),
        formPlazo: item.payment_term_days != null ? String(item.payment_term_days) : '',
        formRut: item.rut || '',
        formMoneda: item.currency != null ? Number(item.currency) : 1,
        formError: '',
    });

    cerrarModal = () => this.setState({ modalAbierto: false, formError: '', guardando: false });

    guardarProveedor = () => {
        const { editandoId, formNombre, formCategoria, formConsignacion, formPlazo, formRut, formMoneda } = this.state;
        const nombre = (formNombre || '').trim();
        if (!nombre) {
            this.setState({ formError: 'El nombre es obligatorio.' });
            return;
        }
        // Cada envío se numera. Si el usuario cierra y reabre el modal mientras una respuesta
        // viaja, la que llega tarde ya no corresponde a lo que hay en pantalla: cerraría el
        // modal nuevo sin avisar, o le pegaría el error del proveedor anterior.
        this.envioActual = (this.envioActual || 0) + 1;
        const envio = this.envioActual;
        const vigente = () => this.envioActual === envio;
        this.setState({ guardando: true, formError: '' });

        const esAlta = editandoId == null;
        const request = {
            method: esAlta ? 'POST' : 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: nombre,
                category: formCategoria,
                isConsignment: formConsignacion ? 1 : 0,
                paymentTermDays: formPlazo === '' ? null : Number(formPlazo),
                rut: formRut || null,
                currency: Number(formMoneda) || 1,
            }),
        };
        const url = config.REACT_APP_BASE_URL + config.REACT_APP_VERSION
            + 'provider/product' + (esAlta ? '' : `/${editandoId}`);

        fetch(url, request)
            .then((results) => results.json())
            .then((data) => {
                if (!vigente()) return; // respuesta de un envío que ya no está en pantalla
                if (data.error > 0) {
                    // El backend manda el motivo puntual (nombre repetido, categoría inválida);
                    // se muestra en el propio modal para no perder lo tipeado.
                    this.setState({ guardando: false, formError: (data.data && data.data.message) || data.message });
                    return;
                }
                this.setState({ modalAbierto: false, guardando: false });
                this.fetchData({ showLoader: false });
            })
            .catch(() => {
                if (!vigente()) return;
                this.setState({ guardando: false, formError: 'No se pudo guardar. Reintentá.' });
            });
    }

    eliminarProveedor = (item) => {
        if (!window.confirm(`¿Eliminar el proveedor "${item.name}"?`)) return;
        const request = {
            method: 'DELETE',
            headers: { 'access-token': localStorage.getItem('token'), 'Content-Type': 'application/json' },
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `provider/product/${item.providerId}`, request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    // El 4204 trae el detalle de qué lo retiene: se dice CUÁNTO, no sólo que no.
                    const d = data.data || {};
                    const partes = [
                        d.productos ? `${d.productos} producto(s)` : null,
                        d.reposiciones ? `${d.reposiciones} reposición(es)` : null,
                        d.ordenes ? `${d.ordenes} orden(es) de pedido` : null,
                        d.faltantes ? `${d.faltantes} registro(s) de faltante` : null,
                    ].filter(Boolean);
                    alert(partes.length
                        ? `No se puede eliminar: tiene ${partes.join(', ')} asociados.`
                        : (data.message || 'No se pudo eliminar.'));
                    return;
                }
                // Si era el último de la página, quedarse en ella mostraría una grilla vacía
                // con el paginador diciendo que hay resultados, y sin forma de volver.
                const ultimoDeLaPagina = this.state.data.length === 1 && this.state.currentPage > 1;
                this.fetchData({ showLoader: false, page: ultimoDeLaPagina ? this.state.currentPage - 1 : undefined });
            })
            .catch(() => alert('No se pudo eliminar. Revisá la conexión y reintentá.'));
    }

    drawRow = (item, index) => {
        return (
            <tr role="row" className="odd" key={item.providerId} style={{ background: index % 2 == 0 ? '#ffffff;' : '#fcfcfc' }}>
                <td tabIndex="0" className="sorting_1">{item.providerId}</td>
                <td>
                    {item.name}
                    {/* ENI-32: se ve en la grilla porque cambia cuándo se le paga, no sólo cómo
                        se lo clasifica — y de acá sale qué productos van a la liquidación. */}
                    {Number(item.is_consignment) ? (
                        <span className="badge badge-info ml-2" style={{ fontSize: '10px' }}
                            title="Su mercadería se paga cuando se vende">Consignación</span>
                    ) : null}
                </td>
                {this.state.role == 1 ? <td style={{ textAlign: 'center' }}>
                    <select
                        className="custom-select custom-select-sm"
                        style={{ width: 'auto', display: 'inline-block', fontSize: '12px' }}
                        value={item.category || 'general'}
                        onChange={(e) => this.updateCategory(item.providerId, e.target.value)}
                    >
                        {PROVIDER_CATEGORIES.map((c) => (
                            <option key={c.value} value={c.value}>{c.label}</option>
                        ))}
                    </select>
                </td> : ''}
                {/* La deuda se etiqueta con `debtCurrency`, que sale de las FACTURAS pendientes y
                    NO de `item.currency`. La del proveedor es sólo el default que heredan las
                    facturas nuevas: marcarlo como USD no convierte las que ya existen, y etiquetar
                    su suma en pesos como "USD 358.140" da un número del orden de magnitud esperado
                    y por lo tanto imposible de detectar mirando. Sin pendientes viene null y se cae
                    a la del proveedor: ahí no hay deuda que etiquetar mal. `debtCurrencies > 1`
                    avisa del caso en que `debt` esté sumando monedas distintas entre sí. */}
                {this.state.role == 1 ? (
                    <td style={{ textAlign: 'right' }}>
                        {Number(item.debtCurrencies) > 1 ? (
                            <span className="text-danger" title="Tiene facturas pendientes en más de una moneda: este total las suma entre sí. Abrí sus facturas para verlas por separado.">
                                ⚠ {item.debt} <small>(monedas mezcladas)</small>
                            </span>
                        ) : `${currencySymbol(item.debtCurrency != null ? item.debtCurrency : item.currency)} ${item.debt}`}
                    </td>
                ) : ''}
                {this.state.role == 1 ? <td style={{ textAlign: 'center' }}>
                    <button
                        type="button"
                        className={`btn btn-sm ${item.orderable ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                        style={{ minWidth: '80px', fontSize: '12px' }}
                        title={item.orderable ? 'Se puede pedir on demand' : 'No se puede pedir on demand (ej: importación)'}
                        onClick={() => this.toggleOrderable(item.providerId, item.orderable)}
                    >
                        {item.orderable ? 'Local' : 'No local'}
                    </button>
                </td> : ''}
                {this.state.role == 1 ? <td style={{ textAlign: 'right' }}>
                    <button type="button" className="btn btn-sm btn-white" style={{ fontSize: '12px' }}
                        onClick={() => this.abrirEdicion(item)}>Editar</button>
                    <button type="button" className="btn btn-sm btn-white text-danger ml-1" style={{ fontSize: '12px' }}
                        onClick={() => this.eliminarProveedor(item)}>Eliminar</button>
                </td> : ''}
            </tr>
        );
    }

    // El modal cubre alta y edición: el mismo formulario, y sólo cambia el verbo.
    renderModal = () => {
        if (!this.state.modalAbierto) return null;
        const esAlta = this.state.editandoId == null;
        return (
            <div id="modal-provider" className="modal" role="dialog" style={MODAL}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{esAlta ? 'Nuevo proveedor' : 'Editar proveedor'}</h4>
                        </div>
                        <div className="modal-body" style={MODAL_BODY}>
                            <div className="form-group">
                                <label>Nombre</label>
                                <input type="text" name="providerName" className="form-control" maxLength={45}
                                    value={this.state.formNombre} autoFocus
                                    onChange={(e) => this.setState({ formNombre: e.target.value })} />
                                <small className="text-muted">Máximo 45 caracteres.</small>
                            </div>
                            <div className="form-group">
                                <label>Categoría</label>
                                <select name="providerCategory" className="form-control"
                                    value={this.state.formCategoria}
                                    onChange={(e) => this.setState({ formCategoria: e.target.value })}>
                                    {/* Al CREAR no se ofrece "General": un proveedor sin clasificar no
                                        aparece en ninguna pantalla de reposición, o sea que nacería
                                        invisible. Al editar sí, porque es el estado de los históricos. */}
                                    {PROVIDER_CATEGORIES
                                        .filter((c) => !esAlta || c.value !== 'general')
                                        .map((c) => (
                                            <option key={c.value} value={c.value}>{c.label}</option>
                                        ))}
                                </select>
                                <small className="text-muted">
                                    Define en qué pantallas de reposición aparece.
                                    {esAlta ? '' : ' "General" no aparece en ninguna.'}
                                </small>
                            </div>

                            {/* ENI-32 — Cuentas por pagar. La modalidad se marca acá y NO en cada
                                producto: los productos la heredan de su proveedor. */}
                            <hr />
                            <div className="form-group">
                                <label className="d-flex align-items-center" style={{ gap: '8px' }}>
                                    <input type="checkbox" name="providerIsConsignment"
                                        checked={this.state.formConsignacion}
                                        onChange={(e) => this.setState({ formConsignacion: e.target.checked })} />
                                    <span>Trabaja en consignación</span>
                                </label>
                                <small className="text-muted">
                                    Su mercadería se paga recién cuando se vende. Todos sus productos quedan marcados
                                    como consignados. Si el mismo proveedor también te vende en firme, cargalo dos
                                    veces (ej: "Devir" y "Devir Consignación").
                                </small>
                            </div>
                            <div className="form-group">
                                <label>Plazo de pago (días)</label>
                                <input type="number" name="providerPaymentTerm" className="form-control" min="0" max="365"
                                    value={this.state.formPlazo}
                                    onChange={(e) => this.setState({ formPlazo: e.target.value })} />
                                <small className="text-muted">
                                    Se usa para calcular el vencimiento de sus facturas. Vacío = sin plazo definido.
                                </small>
                            </div>
                            <div className="form-group">
                                <label>Moneda en la que factura</label>
                                <select name="providerCurrency" className="form-control"
                                    value={this.state.formMoneda}
                                    onChange={(e) => this.setState({ formMoneda: Number(e.target.value) })}>
                                    {CURRENCIES.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
                                </select>
                                <small className="text-muted">
                                    Sus facturas nacen en esta moneda, incluidas las que se crean solas al cargar una
                                    reposición. Se puede cambiar factura por factura si alguna viene en otra moneda.
                                    Cambiarlo acá <b>no</b> toca las facturas ya cargadas.
                                </small>
                            </div>
                            <div className="form-group">
                                <label>RUT</label>
                                <input type="text" name="providerRut" className="form-control" maxLength={12}
                                    value={this.state.formRut}
                                    onChange={(e) => this.setState({ formRut: e.target.value })} />
                                <small className="text-muted">Sólo números. Opcional.</small>
                            </div>

                            {this.state.formError
                                ? <div className="alert alert-danger py-2 mb-0">{this.state.formError}</div>
                                : null}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-accent" disabled={this.state.guardando}
                                onClick={this.guardarProveedor}>
                                {this.state.guardando ? 'Guardando…' : (esAlta ? 'Crear proveedor' : 'Guardar')}
                            </button>
                            <button type="button" className="btn btn-outline-secondary" onClick={this.cerrarModal}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty"><td colSpan="7" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                    {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                </td></tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        const searchActive = hasActiveSearch(this.state.searchInput, this.state.search);

        if (!this.state.loaded) {
            return <TableStateCard loading />;
        }

        // El botón de alta va TAMBIÉN en el estado vacío: si no, sin proveedores cargados no
        // habría forma de crear el primero — que es exactamente cómo quedó trancado staging.
        const botonAlta = this.state.role == 1 ? (
            <button type="button" className="btn btn-sm btn-accent mb-3" onClick={this.abrirAlta}>
                + Crear proveedor
            </button>
        ) : null;

        if (this.state.totalItems === 0 && !searchActive) {
            return (
                <div>
                    {botonAlta}
                    <TableStateCard
                        icon="inventory_2"
                        title="Todavia no hay proveedores para mostrar"
                        message="Cuando existan proveedores cargados, aca vas a ver su deuda y configuracion de pedidos."
                    />
                    {this.renderModal()}
                </div>
            );
        }

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                {botonAlta}
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.sortableHeader('providerId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>ID</th>
                            <th {...this.sortableHeader('name')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '30%' }}>Nombre</th>
                            {this.state.role == 1 ? <th {...this.sortableHeader('category')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '20%' }}>Categoría</th> : ''}
                            {this.state.role == 1 ? <th {...this.sortableHeader('debt')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Deuda</th> : ''}
                            {this.state.role == 1 ? <th {...this.sortableHeader('orderable')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Pedidos</th> : ''}
                            {this.state.role == 1 ? <th className="sorting_disabled" rowSpan="1" colSpan="1" style={{ width: '10%' }}></th> : ''}
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
                {this.renderModal()}
            </div>
        );
    }
}

export default TableProvidersComponent;
